import { Outlet, useParams } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { THEMES } from "../theme/themes";

export default function WorkLayout({ fixed }) {
  const { workId } = useParams(); // /works/:workId/* 用
  const work = (fixed ?? workId) || "default";
  const theme = THEMES[work] ?? THEMES.default;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* ここに作品別の共通Header/Footer/背景などを置ける */}
      <Outlet />
    </ThemeProvider>
  );
}
